module.exports = __webpack_public_path__ + "static/media/memory-mee-brain.d3ee1ae3.jpg";